import { Injectable } from '@angular/core';
import { CategoryModel } from '../models/category.model';

@Injectable({ providedIn: 'root' })
export class CategoryService {
  private categories: CategoryModel[] = [
    { id: 'c1', name: 'Chemistry',    slug: 'chemistry',    iconUrl: 'assets/header/chemistry.png',   order: 1 },
    { id: 'c2', name: 'Hematology',   slug: 'hematology',   iconUrl: 'assets/header/Hematology.png',  order: 2 },
    { id: 'c3', name: 'Immunology',   slug: 'immunology',   iconUrl: 'assets/header/Immunology.png',  order: 3 },
    { id: 'c4', name: 'Urinalysis',   slug: 'urinalysis',   iconUrl: 'assets/header/Urinalisys.png',  order: 4 },
    { id: 'c5', name: 'Centrifuges',  slug: 'centrifuges',  iconUrl: 'assets/header/Centrifuges.png', order: 5 },
    { id: 'c6', name: 'Microscopes',  slug: 'microscopes',  iconUrl: 'assets/header/Microscopes.png', order: 6 },
    { id: 'c7', name: 'Refrigeration', slug: 'refrigeration', iconUrl: 'assets/header/boreas.png', order: 7 },
  ];

  list(): CategoryModel[] {
    return [...this.categories].sort((a,b) => (a.order||0)-(b.order||0));
  }
  getBySlug(slug: string) { return this.categories.find(c => c.slug === slug) || null; }
}
